<template>
  <v-app>
    <loading-circle v-if="loading" size="large" :with-text="true" />
    <data-fetching-error v-else-if="initialDataLoadingError" />
    <div v-else>
      <drawer-large-screen />
      <drawer-small-screen v-model="clientsDrawerForSmallScreen" />
      <toolbar
        :user="$store.getters.user"
        @toolbarSideIconClick="clientsDrawerForSmallScreen = true"
      />

      <!-- Snackbar for notifications -->
      <snackbar />

      <!-- Main content -->
      <v-main>
        <router-view :key="$route.fullPath" />
      </v-main>
    </div>
  </v-app>
</template>

<script>
import LoadingCircle from './components/LoadingCircle'
import DataFetchingError from './components/DataFetchingError'
import DrawerLargeScreen from './components/Drawer/DrawerLargeScreen'
import DrawerSmallScreen from './components/Drawer/DrawerSmallScreen'
import Toolbar from './components/Toolbar'
import Snackbar from './components/Snackbar'
import { getCurrentUser, loadInitialData } from '@/services/initialDataLoader'
import { DJANGO_LOGIN_URL } from '@/constants'

export default {
  components: {
    LoadingCircle,
    DataFetchingError,
    DrawerLargeScreen,
    DrawerSmallScreen,
    Toolbar,
    Snackbar
  },
  data() {
    return {
      loading: true,
      initialDataLoadingError: false,
      clientsDrawerForSmallScreen: false
    }
  },
  async created() {
    try {
      await getCurrentUser()
    } catch (e) {
      if (e.response && e.response.status && e.response.status === 403) {
        window.location.replace(DJANGO_LOGIN_URL)
        return
      } else {
        this.initialDataLoadingError = true
        this.loading = false
      }
    }
    try {
      await loadInitialData()
    } catch (e) {
      this.initialDataLoadingError = true
      console.error(e)
    } finally {
      this.loading = false
    }
  }
}
</script>

<style>
.grand-error > b {
  color: var(--v-primary-base);
  font-size: large;
}
.loading-message {
  color: var(--v-primary-base);
  font-size: large;
}
</style>
